/* global $ */
import isObject from 'lodash/isObject';
import Inputmask from 'inputmask';
import 'babel-polyfill';
import masks from '../masks';
import { supplant } from '../utils/supplant';

export class BaseMask {
    constructor({ el, selector, countryCode }) {
        this.onSubmit = this.onSubmit.bind(this);
        if (el) {
            this.domEl = el;
        } else if (selector) {
            this.domEl = $(selector).get(0);
        }
        this.countryCode = countryCode;
        if (!this.domEl) {
            throw new Error('Input element is not found');
        }
        this.inputmaskOpts = {
            definitions: this.getClassConstructor().getDefinitions(),
            clearMaskOnLostFocus: false,
            clearIncomplete: false,
        };
        this.$el = $(this.domEl);

        this.required = this.$el.data('ruleRequired') || this.$el.prop('required');
        this.form = this.$el.closest('form');

        const dict = masks[this.countryCode.toUpperCase()];
        if (dict) {
            Object.assign(this.inputmaskOpts, this.getMask(dict));
        }
    }

    /**
     * This onSubmit handler empties the value of the mask on non-required fields
     * to not persist empty mask value like "GB___ ___ __" to the server
     * */
    onSubmit() {
        const im = this.$el.data('im');

        if (!im) {
            return;
        }

        const val = this.$el.val();

        if (!val || val === im.getemptymask()) {
            im.remove(); // removing IM plugin to disable value handlers
            this.domEl.value = '';
        }
    }

    getMask(dict) {
        const maskObject = dict[this.getPropertyName(this.getClassConstructor().MASK_NAME)];
        if (typeof maskObject === 'string') {
            return { mask: maskObject };
        }
        if (isObject(maskObject)) {
            return maskObject;
        }
        return {};
    }

    getHelperMessage() {
        const masksMap = masks[this.countryCode.toUpperCase()];
        const configMaskPropertyName = this.getPropertyName(this.getConfig());
        const config = masksMap[configMaskPropertyName];
        if (!config) {
            return '';
        }
        const { phraseCode, ...supplantFields } = config;
        const localizedMsg = window.MASK_PHRASES[phraseCode];
        return supplant(localizedMsg, supplantFields);
    }

    getPropertyName(property) {
        return property;
    }

    getConfig() {
        throw new Error('Implement method getConfig');
    }

    getInvalidMsg() {
        throw new Error('Implement method getInvalidMsg');
    }

    getInvalidMsgAttr() {
        throw new Error('Implement method getInvalidMsgAttr');
    }

    getClassConstructor() {
        throw new Error('Implement method getClassConstructor');
    }

    isCountryAvailableForMask() {
        throw new Error('Implement method isCountryAvailableForMask');
    }

    /**
     * Set attribute value for validation error for postal
     */
    setValidationMessage() {
        const helpMsg = this.getHelperMessage();
        const validMsg = window.MASK_PHRASES[this.getInvalidMsg()];
        const resultValidationMsg = `${validMsg}<br/>${helpMsg}`;
        this.domEl.setAttribute(this.getInvalidMsgAttr(), resultValidationMsg);
        return this;
    }

    /**
     * Display helper message for phone
     * @param {string} helperMessageClass - css selector by className for input hint message
     * @param {function} formatMessage - add additional formatting for message
     */
    addHelperMessages(helperMessageClass, formatMessage = message => message) {
        const helperMsg = this.getHelperMessage().replace('.', '');
        if (helperMessageClass) {
            Array.prototype.slice
                .apply(document.querySelectorAll(helperMessageClass))
                .forEach(element => {
                    // eslint-disable-next-line
                    element.innerHTML = formatMessage(helperMsg);
                });
        }

        return this;
    }

    /**
     * Create Inputmask instances and pass it by mean of $.data
     * return {undefined}
     */
    initMask() {
        let im = this.$el.data('im');

        if (this.isCountryAvailableForMask(this.countryCode)) {
            if (im) {
                im.remove();
            }
            im = new Inputmask(this.inputmaskOpts).mask(this.domEl);
            this.$el.data('im', im);

            if (!this.required) {
                this.form.submit(this.onSubmit);
            }

            // hack to enable JIT validation wihtout initial blur
            this.$el.one('keyup', () => {
                this.$el.valid();
            });

            this.$el.on('keyup', ev => {
                if (ev.keyCode === 13) {
                    ev.preventDefault();
                }
            });

            this.$el.on('keydown', ev => {
                if (ev.keyCode === 13) {
                    im.enterKeydownValidation = true;
                    ev.preventDefault();
                }
            });
        }
        return this;
    }
}
